import type { PasswordConditions } from "~/types";

export function getPasswordConditions(_password: string): PasswordConditions {
  const password = _password.trim();

  return {
    hasMinimumLength: password.length >= 8,
    hasLowerCase: /[a-z]/.test(password),
    hasUpperCase: /[A-Z]/.test(password),
    hasNumber: /\d/.test(password),
    // needs to have one of these special characters !#$%*@^-
    hasSpecialCharacter: /([!#$%*@^-]+)/g.test(password),
  };
}
